import React from 'react';
import { QR_APP_DATA, QR_MAP_DATA } from '../../utils/qrData';

const RED = '#B5452A';
const DARK = '#2D2016';
const HEAVY = "'Arial Black', 'Arial', sans-serif";

const HeroSection = ({ assets }) => (
  <div style={{ position: 'relative', height: '232px', overflow: 'hidden' }}>
    <img src={assets.hero4 || assets.food || ''} alt="" data-testid="brochure-hero-image" style={{ width: '100%', height: '232px', objectFit: 'cover', display: 'block' }} />
    <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(30,20,12,0.6) 0%, rgba(30,20,12,0) 35%, rgba(30,20,12,0) 70%, rgba(30,20,12,0.35) 100%)' }} />
    <div style={{ position: 'absolute', top: '12px', left: '14px', display: 'flex', alignItems: 'center', gap: '8px' }}>
      <img src={assets.logo || ''} alt="Central Hotel" style={{ height: '36px', borderRadius: '4px' }} />
      <div>
        <p style={{ color: '#FFF', fontSize: '12px', fontWeight: '800', letterSpacing: '1.5px' }}>CENTRAL HOTEL</p>
        <p style={{ color: '#F2C9A0', fontSize: '7.5px', letterSpacing: '2px', fontWeight: '700' }}>RESTAURANT & KITCHEN</p>
      </div>
    </div>
    <div data-testid="brochure-price-badge" style={{
      position: 'absolute', right: '14px', bottom: '6px', width: '118px', height: '118px', borderRadius: '50%',
      background: RED, border: '4px solid #F5EDE4', boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#FFF', transform: 'rotate(-8deg)'
    }}>
      <span style={{ fontSize: '11px', fontWeight: '800', letterSpacing: '2px' }}>4 ÇEŞİT</span>
      <span style={{ fontSize: '44px', fontWeight: '900', lineHeight: '1', fontFamily: HEAVY }}>€10</span>
      <span style={{ fontSize: '8.5px', fontWeight: '700', letterSpacing: '1.5px', marginTop: '2px' }}>SADECE / ONLY</span>
    </div>
  </div>
);

const DishSteps = () => (
  <div style={{ display: 'flex', gap: '5px', margin: '9px 0 8px' }}>
    {['Çorba', 'Ana Yemek', 'Yardımcı', 'Salata'].map((t, i) => (
      <div key={t} style={{ flex: 1, background: DARK, color: '#F5EDE4', borderRadius: '6px', padding: '5px 2px', textAlign: 'center' }}>
        <span style={{ display: 'block', fontSize: '13px', fontWeight: '900', color: '#F2A36B', lineHeight: '1' }}>{i + 1}</span>
        <span style={{ fontSize: '8.5px', fontWeight: '800' }}>{t}</span>
      </div>
    ))}
  </div>
);

const QrRow = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', background: '#FFF8F0', border: `2px solid ${RED}`, borderRadius: '10px', padding: '7px 10px' }}>
    {[
      { src: QR_APP_DATA, t: 'SİPARİŞ VER', s: 'Order · Naruči · Заказать', id: 'app' },
      { src: QR_MAP_DATA, t: 'KONUM', s: 'Location · Lokacija · Адрес', id: 'map' }
    ].map(q => (
      <div key={q.id} style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '6px' }} data-testid={`brochure-qr-${q.id}`}>
        <img src={q.src} alt={q.t} style={{ width: '84px', height: '84px', display: 'block' }} />
        <div>
          <p style={{ fontSize: '12px', fontWeight: '900', color: RED }}>{q.t}</p>
          <p style={{ fontSize: '7.5px', color: '#5C4A3A', lineHeight: '1.35' }}>{q.s}</p>
        </div>
      </div>
    ))}
  </div>
);

export const BrochureCampaignContent = ({ assets }) => (
  <>
    <HeroSection assets={assets} />
    <div style={{ padding: '12px 20px 14px', display: 'flex', flexDirection: 'column', height: 'calc(100% - 232px)' }}>
      <p style={{ fontSize: '25px', fontWeight: '900', color: DARK, lineHeight: '1.05', fontFamily: HEAVY, letterSpacing: '-0.5px' }}>
        4 ÇEŞİT YEMEK<br /><span style={{ color: RED }}>SADECE €10!</span>
      </p>
      <DishSteps />
      <div style={{ fontSize: '9.6px', color: '#4A3A2C', lineHeight: '1.5', borderLeft: `3px solid ${RED}`, paddingLeft: '8px' }}>
        <p><b>EN</b> 4 dishes, only €10: Soup + Main + Side + Salad</p>
        <p><b>ME</b> 4 jela, samo €10: Supa + Glavno jelo + Prilog + Salata</p>
        <p><b>RU</b> 4 блюда, всего €10: Суп + Основное + Гарнир + Салат</p>
      </div>
      <p style={{ fontSize: '9.6px', color: '#5C4A3A', marginTop: '6px', fontStyle: 'italic' }}>Her gün farklı menü! Uygulamamızdan sipariş verin, kapınıza gelsin.</p>
      <div style={{ flex: 1 }} />
      <QrRow />
      <p style={{ textAlign: 'center', paddingTop: '7px', fontSize: '9px', fontWeight: '900', color: DARK, letterSpacing: '1px' }}>
        13 Jula 6, Budva · +382 69 144 043 · centralhotel.org
      </p>
    </div>
    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '5px', background: RED, zIndex: 10 }} />
  </>
);

export default BrochureCampaignContent;
